import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { CheckCircleIcon } from 'lucide-react';
export function ClosingSection() {
  const trustBadges = ['Paiement 100% sécurisé', 'Accès immédiat sur ton téléphone', 'Garantie remboursement 30 jours', 'Tu gardes tout même si tu te désistes'];
  return <section className="py-10 md:py-16 px-4 md:px-8 bg-gradient-to-b from-warm-white to-blush" data-id="element-12">
      <motion.div initial={{
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} className="max-w-4xl mx-auto" data-id="element-13">
        <h2 className="font-playfair text-2xl sm:text-3xl md:text-5xl font-bold text-burgundy text-center mb-6 md:mb-12" data-id="element-14">
          Ton choix, maintenant.
        </h2>

        <div className="space-y-5 md:space-y-8 mb-8 md:mb-12 text-base sm:text-lg md:text-xl font-lato" data-id="element-15">
          <p className="text-gray-700 text-center" data-id="element-16">
            Dans quelques semaines, la Fête des Mères va arriver.
          </p>

          <p className="text-gray-700 text-center" data-id="element-17">
            Et il n'y a que deux types de personnes :
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6" data-id="element-18">
            <div className="bg-gray-100 rounded-lg md:rounded-xl p-4 md:p-6 border-2 border-gray-300" data-id="element-19">
              <p className="text-xl md:text-2xl mb-2 md:mb-3" data-id="element-20">❌</p>
              <p className="font-bold text-gray-600 mb-1 md:mb-2 text-sm sm:text-base" data-id="element-21">
                Celles qui vont acheter un cadeau banal à la dernière minute.
              </p>
              <p className="text-gray-500 text-xs sm:text-sm md:text-base" data-id="element-22">
                Fleurs qui fanent. Chocolats oubliables. Sentiment de "j'aurais
                pu faire mieux".
              </p>
            </div>

            <div className="bg-white rounded-lg md:rounded-xl p-4 md:p-6 border-2 border-rose-gold shadow-lg" data-id="element-23">
              <p className="text-xl md:text-2xl mb-2 md:mb-3" data-id="element-24">✅</p>
              <p className="font-bold text-burgundy mb-1 md:mb-2 text-sm sm:text-base" data-id="element-25">
                Celles qui vont créer un souvenir.
              </p>
              <p className="text-gray-700 text-xs sm:text-sm md:text-base" data-id="element-26">
                Un cadeau beau, gourmand, fait main. Une boîte si parfaite
                qu'elle semblera sortir d'une boutique de luxe.
              </p>
            </div>
          </div>

          <div className="bg-blush rounded-xl md:rounded-2xl p-5 md:p-8 text-center" data-id="element-27">
            <p className="font-playfair text-xl sm:text-2xl md:text-3xl text-burgundy italic mb-2 md:mb-4" data-id="element-28">
              « C'est vraiment toi qui as fait ça ? » 🥹
            </p>
            <p className="text-sm sm:text-base text-gray-700" data-id="element-29">
              Pour 9,97$, tu choisis quelle personne tu veux être dimanche.
            </p>
          </div>
        </div>

        <div className="text-center mb-6 md:mb-8" data-id="element-30">
          <CTAButton large scrollTo="pack-pricing" data-id="element-31">
            OUI ! JE VEUX ÉPATER MA MAMAN 🍓
          </CTAButton>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-4 max-w-2xl mx-auto" data-id="element-32">
          {trustBadges.map((badge, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-center gap-2 justify-center" data-id="element-33">
              <CheckCircleIcon className="w-4 h-4 md:w-5 md:h-5 text-green-600 flex-shrink-0" data-id="element-34" />
              <span className="text-xs sm:text-sm text-gray-700 font-lato" data-id="element-35">
                {badge}
              </span>
            </motion.div>)}
        </div>
      </motion.div>
    </section>;
}